<template>
  <div>
    <b-tabs
        :pills="tabs.isPills"
        :small="tabs.isSmall"
        :justified="tabs.isJustified"
        :isFill="tabs.isFill"
        :end="tabs.isEnd"
        :vertical="tabs.isVertical"
        content-class="mt-3"
        defaultActiveKey="stage"
    >
      <template v-if="showLogo" #tabs-start>
        <b-img
            v-if="sessionCompanyLogoURL"
            v-bind="mainPropsLogo"
            style="object-fit: scale-down; height: 5vh"
            rounded
            :src="sessionCompanyLogoURL"
            fluid
            alt="Fluid image"
        />
      </template>
      <b-tab
          v-for="(aSection, index) in availSections"
          :key="index"
          :title="aSection.title"
      >
        <template #title>
          <h5 style="padding-top: 25px;">
            <b-icon
                v-if="aSection.icon"
                :icon="aSection.icon"
                aria-hidden="true"
            />
            {{ aSection.title }}
          </h5>
        </template>
        <component
            :is="aSection.component"
            v-bind="Object.assign({}, propsData)"
            :ref="aSection.componentName"
            @add-data-click="handleAddDataButtonClick"
        >
        </component>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SessionStage from "./sessionStage";
import SessionAgenda from "./sessionAgenda";
import SessionSpeakers from "./sessionSpeakers";
import SessionSponsors from "./sessionSponsors";

export default {
  name: "Sessions_Session_Body",
  components: {},
  props: {
    session: {
      type: Object,
      default: () => {}
    },
    profile: {
      type: Object,
      default: () => {}
    },
    roomData: {
      type: Object,
      default: () => {}
    },
    avResources: {
      type: Object,
      default: () => {}
    },
    theme: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({}),
    sessionCompanyLogoURL(){
      return this.session && this.session.session &&
      this.session.session.companyImgURL ? this.session.session.companyImgURL : null
    },
    availSections() {
      return this.sections.filter(x => {
        return x.avail === true;
      });
    },
    propsData() {
      return {
        profile: this.profile,
        session: this.session,
        roomdata: this.roomData,
        avresources: this.avResources
      };
    }
  },
  methods: {
    handleAddDataButtonClick() {
      this.$emit('add-data-click');
    }
  },
  data() {
    return {
      mainPropsLogo: { blank: false, blankColor: "#777", class: "m1" },
      showLogo: true,
      screen: {
        bgColor: "#222222"
      },
      tabs: {
        isPills: false,
        isSmall: true,
        isJustified: true,
        isFill: true,
        isEnd: false,
        isVertical: false
      },
      tab: {
        titleLinkAttributes: {
          color: "#5695e0"
        },
        hexColorTabBg: "#777",
        hexColorTabText: "#777",
        hexColorScreen: "#777"
      },
      sections : [
        {
          title: "Stage",
          id: "stage",
          component: SessionStage,
          componentName: "SessionStage",
          avail: true
        },
        {
          title: "Agenda",
          id: "agenda",
          component: SessionAgenda,
          componentName: "SessionAgenda",
          avail: true
        },
        {
          title: "Speakers",
          id: "speakers",
          component: SessionSpeakers,
          componentName: "SessionSpeakers",
          avail: true
        },
        {
          title: "Sponsors",
          id: "sponsors",
          component: SessionSponsors,
          componentName: "SessionSponsors",
          avail: true
        },
        {
          title: "Photo Booth",
          id: "photoBooth",
          component: SessionSponsors,
          componentName: "SessionSponsors",
          avail: true
        }
      ],
    };
  }
};
</script>

<style lang="scss" scoped>
.tab-test {
  background-color: green;
  color: #0dbc79;
}
.upload-btn {
  cursor: pointer;
  background-color: #fff;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  max-width: 220px;
  height: 50px;
  border: none;
  letter-spacing: 0.05em;
  align-items: center;
  color: var(--theme-color);
  margin-left: 16px;
  border-radius: 4px;
  transition: all 0.2s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  .content {
    display: flex;
    #blogger-publishing-video {
      width: 0;
    }
    #guide-publishing-image {
      width: 0;
    }
    .ico {
      margin-right: 3px;
      img {
        cursor: pointer;
        position: relative;
        top: 50%;
        right: 4px;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        height: 24px;
        width: 24px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        -webkit-box-pack: center;
        -ms-flex-pack: center;
        justify-content: center;
        background: rgba(85, 126, 251, 0.1);
        border-radius: 8px;
      }
      svg {
        height: 30px;
      }
    }
    .watch-video {
      margin-top: 5px;
    }
    .btn-content {
      margin-top: 2px;
      font-family: Nunito;
      font-style: normal;
      font-size: 16px;
      line-height: 22px;
      color: var(--theme-color);
    }
  }
}
.upload-btn:focus {
  outline: none;
  box-shadow: none;
}
</style>
